import React from 'react';
import { Box, Typography } from '@mui/material';
import { Logo } from '@app/ui/pages/landing-page/header/logo/logo.component';
import { PhoneBlock } from '@app/ui/pages/landing-page/header/phone-block/phone-block.component';
import {
  DesktopOnly,
  LaptopOnly,
} from '@app/ui/pages/landing-page/header/header.styles';
import { Icon } from '@app/ui/pages/landing-page/header/icon/icon.component';
// @ts-ignore
import phoneIcon from '@app/assets/phone.svg';
import { PHONE_FOR_CALL, PHONE_FOR_CALL_SECOND } from '@app/ui/common/common.constants';
import { HeaderButtons } from '@app/ui/components/header/HeaderButtons';
import { shouldShowMainPhone } from '@app/utils/domainHelpers';

interface HeaderProps {
  onRequestClick?: () => void;
  isAuthenticated: boolean;
  userName?: string;
  userPhone?: string;
  onLoginClick: () => void;
  onPaymentClick: () => void;
  onProfileClick: () => void;
  onLogoutClick: () => void;
}

export const Header: React.FC<HeaderProps> = ({ 
  onRequestClick,
  isAuthenticated,
  userName,
  userPhone,
  onLoginClick,
  onPaymentClick,
  onProfileClick,
  onLogoutClick,
}) => {
  const hrefRootUrl = '/';
  // Основной телефон показываем только на ok-telecom.ru
  const showMainPhone = shouldShowMainPhone();
  // На мобильных иконка-звонок ведёт на основной телефон только на ok-telecom.ru,
  // на остальных доменах — на второй номер
  const phoneForMobile = showMainPhone ? PHONE_FOR_CALL : PHONE_FOR_CALL_SECOND;
  return (
    <>
      {/* @ts-ignore */}
      <DesktopOnly>
        <Box display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
          <Logo href={hrefRootUrl} />
          {/* Телефоны + компактная ссылка на Telegram-бота под номером
              (бот показывается на доменах без основного телефона) */}
          <PhoneBlock phone={PHONE_FOR_CALL} phoneSecond={PHONE_FOR_CALL_SECOND} description='Подключиться' />
        </Box>
        <Box display='flex' flexDirection='row' justifyContent='center' alignItems='center'>
          <HeaderButtons
            isAuthenticated={isAuthenticated}
            userName={userName}
            userPhone={userPhone}
            onLoginClick={onLoginClick}
            onPaymentClick={onPaymentClick}
            onProfileClick={onProfileClick}
            onLogoutClick={onLogoutClick}
          />
        </Box>
      </DesktopOnly>
      {/* @ts-ignore */}
      <LaptopOnly>
        <div>
          <Logo href={hrefRootUrl} />
        </div>
        <Box display='flex' flexDirection='row'>
          <Icon href={`tel:${phoneForMobile}`} iconUrl={phoneIcon} />
          <HeaderButtons
            isAuthenticated={isAuthenticated}
            userName={userName}
            userPhone={userPhone}
            onLoginClick={onLoginClick}
            onPaymentClick={onPaymentClick}
            onProfileClick={onProfileClick}
            onLogoutClick={onLogoutClick}
          />
        </Box>
      </LaptopOnly>
    </>
  );
};
